import { useAppStore } from '@store'
import {
  beginHistoryBatch,
  clearHistoryEngine,
  commitHistoryBatchSnapshot,
  endHistoryBatch,
  getHistoryBatchDepth,
  popHistorySuppress,
  pushHistorySuppress,
} from '../store/history'
import { captureHistorySnapshot, serializeHistorySnapshot } from '../store/history/snapshot'

export { getHistoryBatchDepth }

type StoreWithHistoryBatch = ReturnType<typeof useAppStore.getState>

export function pauseHistoryRecording(): void {
  useAppStore.getState().pauseHistory()
}

export function resumeHistoryRecording(): void {
  useAppStore.getState().resumeHistory()
}

export function runWithoutHistoryRecording(run: () => void): void {
  pushHistorySuppress()
  try {
    run()
  } finally {
    popHistorySuppress()
  }
}

export async function runWithoutHistoryRecordingAsync<T>(run: () => Promise<T>): Promise<T> {
  pushHistorySuppress()
  try {
    return await run()
  } finally {
    popHistorySuppress()
  }
}

export function runWithHistoryBatch(run: () => void): void {
  const beforeSerialized = serializeHistorySnapshot(
    captureHistorySnapshot(useAppStore.getState() as StoreWithHistoryBatch),
  )
  beginHistoryBatch(beforeSerialized)
  try {
    run()
  } finally {
    const baseline = endHistoryBatch()
    if (baseline) {
      commitHistoryBatchSnapshot(baseline)
    }
  }
}

export async function runWithHistoryBatchAsync<T>(run: () => Promise<T>): Promise<T> {
  const beforeSerialized = serializeHistorySnapshot(
    captureHistorySnapshot(useAppStore.getState() as StoreWithHistoryBatch),
  )
  beginHistoryBatch(beforeSerialized)
  try {
    return await run()
  } finally {
    const baseline = endHistoryBatch()
    if (baseline) {
      commitHistoryBatchSnapshot(baseline)
    }
  }
}

export function establishHistoryBaseline(): void {
  clearHistoryEngine()
}
